import { MovieRemoveOutlineIcon } from './MovieRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 6FC268E0-F315-4818-B25F-0576DA4B9A84
 * name movie-remove-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-remove-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateRemoveOutlineIcon = MovieRemoveOutlineIcon;
export default SlateRemoveOutlineIcon